import CityPage from "../CityPage";

export default function Lisle() {
  return <CityPage slug="lisle" />;
}
